import { makeStyles } from "@mui/styles";

export const useStyles = makeStyles(() => ({
	logoMobile: {
		width: "45vw",
    height: "45vw",
    borderRadius: "50%",
    marginBottom: "20px",
    border: "7px solid black"
	},
	logo: {
		width: "20vw",
    height: "20vw",
    borderRadius: "50%",
    marginBottom: "20px",
    border: "7px solid black"
	},
  form: {
    width: "60%",
    margin: "auto",
  },
  formMobile: {

  }
}));
